export const EBOOK_TOOLKIT = { invoiceItemPriceId: 'Ebook-Fee-USD', price: 2900, discountPrice: 1900, currencyCode: 'USD' };

export const EBOOK_GIFT_PRICE = 0;
